const ANCHOR_NAME = 'anchor-point';

export const shapeNames = {
  anchor: ANCHOR_NAME,
  anchorIn: `${ANCHOR_NAME}-in`,
  anchorOut: `${ANCHOR_NAME}-out`,
  anchorTitle: 'anchor-point-title',
  body: 'node-body',
  childNode: 'child-node',
  childNodeWrapper: 'child-node-wrapper',
  corner: 'corner',
  delete: 'delete',
  deleteCircle: 'delete-circle',
  deleteIcon: 'delete-icon',
  descBottom: 'desc-bottom',
  divider: 'divider',
  emptyBody: 'node-body-empty',
  errorHighlight: 'error-highlight',
  footer: 'footer',
  footerContentWrapper: 'footer-content-wrapper',
  footerText: 'footer-text',
  icon: 'icon-image',
  iconBackground: 'icon-background',
  label: 'label',
  linkIcon: 'link-icon',
  nodeId: 'node-id',
  noteIcon: 'note-icon',
  // numUsers
  numUsersGroup: 'num-users-groups',
  numUsersWrapper: 'num-users-wrapper',
  numUsersIcon: 'num-users-icon',
  numUsersText: 'num-users-text',
  numUsersPrimaryText: 'num-users-primary-text',
  numUsersSecondaryText: 'num-users-secondary-text',
  // numEnteredUsers
  numUsersEnteredGroup: 'num-users-entered-group',
  numUsersEnteredWrapper: 'num-users-entered-wrapper',
  numUsersEnteredIcon: 'num-users-entered-icon',
  numUsersEnteredPrimaryText: 'num-users-entered-primary-text',
  numUsersEnteredSecondaryText: 'num-users-entered-secondary-text',
  //numExitedUsers
  numUsersExitedGroup: 'num-users-exited-group',
  numUsersExitedWrapper: 'num-users-exited-wrapper',
  numUsersExitedIcon: 'num-users-exited-icon',
  numUsersExitedPrimaryText: 'num-users-exited-primary-text',
  numUsersExitedSecondaryText: 'num-users-exited-secondary-text',

  overlayGrey: 'overlay-grey',
  overlayPurple: 'overlay-purple',
  segmentButtonLink: 'segment-button-link',
  shadow: 'shadow',
  title: 'node-title',
  warningMessage: 'warning-message',
  wrapper: 'wrapper',
};

const createGroupId = (str: string) => `${str}-group`;

const ANCHOR_GROUP_ID = 'anchor-group';

export const groupIds = {
  anchor: ANCHOR_GROUP_ID,
  anchorIn: `${ANCHOR_GROUP_ID}-in`,
  anchorOut: `${ANCHOR_GROUP_ID}-out`,
  delete: 'delete-group',
  descBottom: createGroupId(shapeNames.descBottom),
  footer: createGroupId(shapeNames.footer),
  footerContent: 'footer-content-group',
  icon: 'icon-group',
  numUsers: shapeNames.numUsersGroup,
  numUsersEntered: shapeNames.numUsersEnteredGroup,
  numUsersExited: shapeNames.numUsersExitedGroup,
  overlay: 'overlay-group',
  title: createGroupId(shapeNames.title),
  warning: 'warning-group',
};

/**
 * The type of shape or group
 *
 * Used for commonly repeated shapes, such as tooltips
 */
export enum ShapeType {
  /** The background of a shape */
  Background = 'background',
  /** The underline for a text shape */
  Underline = 'underline',
  /** The tooltip group */
  Tooltip = 'tooltip',
  /** The arrow pointing from the tooltip container to the text */
  TooltipArrow = 'tooltipArrow',
  /** The tooltip wrapper and background */
  TooltipContainer = 'tooltipContainer',
  /** The text of a tooltip */
  TooltipText = 'tooltipText',
}

/**
 * Additional properties added to shapes
 */
export enum ShapeProp {
  /** The text of the associated tooltip */
  TooltipText = 'tooltipText',
  /** The text of the associated tooltip */
  UnderlineType = 'underlineType',
}

export enum CanvasProp {
  /** The text of the associated tooltip */
  Tooltip = 'tooltip',
}

export enum ButtonType {
  ButtonLink = 'buttonLink',
  Link = 'link',
  NumUsers = 'numUsers',
  NumUsersEntered = 'numUsersEntered',
  NumUsersExited = 'numUsersExited',
}

export enum GroupName {
  ChildNode = 'child-node-group',
}
